import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import SeoMeta from '../components/SeoMeta';
import { ObfuscatedEmail } from '../components/ObfuscatedEmail';

export default function CGVPage() {
  return (
    <div className="min-h-screen bg-slate-50">
      <SeoMeta
        title="Conditions Générales de Vente"
        description="CGV du service Drone Maps : formules d'abonnement Solo Mensuel et Annuel, modalités de paiement, résiliation et service client. Éditeur BOD CORP."
        keywords="CGV Drone Maps, tarifs drone SaaS, abonnement mensuel drone, abonnement annuel drone, BOD CORP"
      />
      <div className="max-w-4xl mx-auto px-4 py-12">
        <Link to="/" className="inline-flex items-center gap-2 text-sky-600 hover:text-sky-700 mb-8">
          <ArrowLeft className="w-4 h-4" />
          Retour à l'accueil
        </Link>
        
        <h1 className="text-3xl font-bold text-slate-900 mb-8 font-[Barlow]">Conditions Générales de Vente</h1>
        
        <div className="bg-white rounded-xl p-8 shadow-sm space-y-8">
          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">1. Objet</h2>
            <p className="text-slate-600 leading-relaxed">
              Les présentes Conditions Générales de Vente (CGV) régissent les relations contractuelles entre 
              BOD CORP, éditeur du service Drone Maps, et tout utilisateur souscrivant à un abonnement payant.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">2. Vendeur</h2>
            <p className="text-slate-600 leading-relaxed">
              <strong>BOD CORP</strong><br />
              60 RUE FRANCOIS IER<br />
              75008 PARIS, France<br />
              SIRET : 48332066900037<br />
              Email : <ObfuscatedEmail linkClassName="text-sky-600 hover:underline" />
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">3. Offres et tarifs</h2>
            <p className="text-slate-600 leading-relaxed mb-4">
              Drone Maps propose les formules d'abonnement suivantes :
            </p>
            <div className="overflow-x-auto">
              <table className="w-full text-sm border-collapse">
                <thead>
                  <tr className="bg-slate-100">
                    <th className="p-3 text-left border border-slate-200">Formule</th>
                    <th className="p-3 text-left border border-slate-200">Prix</th>
                    <th className="p-3 text-left border border-slate-200">Engagement</th>
                    <th className="p-3 text-left border border-slate-200">Fonctionnalités</th>
                  </tr>
                </thead>
                <tbody className="text-slate-600">
                  <tr>
                    <td className="p-3 border border-slate-200 font-medium">Freemium</td>
                    <td className="p-3 border border-slate-200">Gratuit</td>
                    <td className="p-3 border border-slate-200">Aucun</td>
                    <td className="p-3 border border-slate-200">3 missions, PDF avec filigrane</td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-slate-200 font-medium">Solo Mensuel</td>
                    <td className="p-3 border border-slate-200">19€/mois TTC</td>
                    <td className="p-3 border border-slate-200">Sans engagement</td>
                    <td className="p-3 border border-slate-200">Missions illimitées, PDF complet</td>
                  </tr>
                  <tr>
                    <td className="p-3 border border-slate-200 font-medium">Solo Annuel</td>
                    <td className="p-3 border border-slate-200">190€/an TTC</td>
                    <td className="p-3 border border-slate-200">12 mois</td>
                    <td className="p-3 border border-slate-200">Missions illimitées, PDF complet, 2 mois offerts</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <p className="text-slate-600 leading-relaxed mt-4">
              Les prix sont indiqués en euros, toutes taxes comprises (TTC). BOD CORP se réserve le droit de 
              modifier ses tarifs à tout moment. Les nouveaux tarifs s'appliqueront aux nouvelles souscriptions 
              et aux renouvellements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">4. Commande et paiement</h2>
            <p className="text-slate-600 leading-relaxed">
              La souscription à un abonnement payant s'effectue en ligne sur le site drone-maps.eu. Le paiement 
              est réalisé par carte bancaire via la plateforme sécurisée Stripe.<br /><br />
              La commande est confirmée dès réception du paiement. Un email de confirmation est envoyé à 
              l'adresse fournie lors de l'inscription.<br /><br />
              <strong>Moyens de paiement acceptés :</strong> Carte bancaire (Visa, Mastercard, American Express)
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">5. Durée et renouvellement</h2>
            <p className="text-slate-600 leading-relaxed">
              <strong>Abonnement mensuel :</strong> L'abonnement est conclu pour une durée d'un mois et se 
              renouvelle automatiquement par tacite reconduction, sauf résiliation.<br /><br />
              <strong>Abonnement annuel :</strong> L'abonnement est conclu pour une durée de 12 mois et se 
              renouvelle automatiquement par tacite reconduction, sauf résiliation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">6. Droit de rétractation</h2>
            <p className="text-slate-600 leading-relaxed">
              Conformément à l'article L.221-28 du Code de la consommation, le droit de rétractation ne peut 
              être exercé pour les contrats de fourniture de contenu numérique non fourni sur un support matériel 
              dont l'exécution a commencé avec l'accord préalable exprès du consommateur.<br /><br />
              En souscrivant à un abonnement Drone Maps et en accédant immédiatement au service, vous renoncez 
              expressément à votre droit de rétractation.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">7. Résiliation</h2>
            <p className="text-slate-600 leading-relaxed">
              <strong>Par l'utilisateur :</strong><br />
              • L'abonnement peut être résilié à tout moment depuis les paramètres du compte ou par email à <ObfuscatedEmail linkClassName="text-sky-600 hover:underline" /><br />
              • La résiliation prend effet à la fin de la période de facturation en cours<br />
              • Aucun remboursement au prorata n'est effectué<br /><br />
              <strong>Par BOD CORP :</strong><br />
              • En cas de violation des CGU ou CGV<br />
              • En cas de non-paiement<br />
              • En cas de cessation du service (avec préavis de 30 jours)
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">8. Codes promotionnels</h2>
            <p className="text-slate-600 leading-relaxed">
              Des codes promotionnels peuvent être proposés ponctuellement. Ces codes :<br /><br />
              • Sont à usage unique sauf mention contraire<br />
              • Ne sont pas cumulables avec d'autres offres<br />
              • Ont une durée de validité limitée<br />
              • Peuvent être soumis à des conditions spécifiques
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">9. Facturation</h2>
            <p className="text-slate-600 leading-relaxed">
              Une facture est émise et envoyée par email à chaque paiement. Les factures sont également 
              accessibles depuis l'espace client. BOD CORP est assujettie à la TVA française.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">10. Service client</h2>
            <p className="text-slate-600 leading-relaxed">
              Pour toute question relative à votre abonnement, notre service client est disponible :<br /><br />
              Email : <ObfuscatedEmail linkClassName="text-sky-600 hover:underline" /><br />
              Délai de réponse : 48h ouvrées
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">11. Médiation</h2>
            <p className="text-slate-600 leading-relaxed">
              En cas de litige, vous pouvez recourir gratuitement au service de médiation de la consommation. 
              Le médiateur peut être saisi après une première réclamation écrite restée sans réponse satisfaisante 
              dans un délai de 60 jours.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-slate-900 mb-4">12. Droit applicable</h2>
            <p className="text-slate-600 leading-relaxed">
              Les présentes CGV sont soumises au droit français. En cas de litige, les tribunaux de Paris 
              seront seuls compétents, sous réserve des dispositions légales impératives applicables aux consommateurs.
            </p>
          </section>

          <p className="text-sm text-slate-400 pt-4 border-t border-slate-200">
            Dernière mise à jour : Février 2026
          </p>
        </div>
      </div>
    </div>
  );
}
